// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sizeVariantValues } from "@conklin/MobiusOverrides/FormField/formStyles";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { xBaseTheme } from "@conklin/XDL/types";
import { color } from "@conklin/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        border: "rectangle",
        sizeVariant: "default",
        mergeCss: true,
        labelProps: {
            mergeCss: true,
            size: 12,
            weight: fontConfig.weight.regular,
            color: "text",
            css: css`
                letter-spacing: 0;
                line-height: 15px;
                min-height: initial;
            `,
        },
        errorProps: {
            mergeCss: true,
            size: 14,
            weight: fontConfig.weight.regular,
            color: "danger.main",
            css: css`
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        hintProps: {
            mergeCss: true,
            size: 14,
            weight: fontConfig.weight.regular,
            css: css`
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        backgroundColor: "common.ui1",
        cssOverrides: {
            formInputWrapper: css`
                &&& {
                    input,
                    textarea,
                    select {
                        transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
                        box-shadow: inset 0 1px 0 0 ${color("common.ui7", 0.1)};
                        text-overflow: ellipsis;
                        line-height: 17px;

                        &,
                        &:focus {
                            ${({ _iconPosition, _sizeVariant }: any) =>
                                _iconPosition === "right" &&
                                `padding-right: ${
                                    sizeVariantValues[_sizeVariant as keyof typeof sizeVariantValues].height - 4
                                }px;`}

                            ${({ _iconPosition, _sizeVariant }: any) =>
                                _iconPosition === "left" &&
                                ` padding-left: ${
                                    sizeVariantValues[_sizeVariant as keyof typeof sizeVariantValues].height - 4
                                }px;`}
                        }

                        &::placeholder {
                            font-size: 14px;
                            line-height: 17px;
                            font-style: italic;
                            max-width: 100%;
                            color: ${color("common.ui4")};
                        }

                        &:hover:not(:disabled) {
                            border: 1px solid ${color("common.ui10")};
                        }
                        &:focus:not(:disabled) {
                            border: 1px solid ${color("common.ui11")};
                        }
                    }

                    // This is custom style for select left icon to be used in Time Picker
                    ${IconWrapper} + select {
                        ${({ _sizeVariant }: any) =>
                            `padding-left: ${
                                sizeVariantValues[_sizeVariant as keyof typeof sizeVariantValues].height - 4
                            }px;`}
                    }
                    ${IconWrapper}.left-icon {
                        left: 0;
                    }

                    textarea {
                        overflow-y: auto;
                    }

                    input:placeholder-shown ~ .clear {
                        display: none;
                    }
                }
            `,
            inputSelect: css`
                box-shadow: inset 0 1px 0 0 ${color("common.ui7", 0.1)};
            `,
        },
    },
} as xBaseTheme["formField"];
